import { useMemo } from 'react';
import { PictogramName } from '@cbhq/cds-illustrations';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Pictogram } from '@cbhq/cds-web/illustrations';
import { Grid, HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextHeadline, TextTitle3 } from '@cbhq/cds-web/typography';

import { FULL_PAGE_MAX_WIDTH } from ':cloud/widgets/product/constants';

const stakingSolutionsContent = [
  {
    title: 'Programmatic access',
    description: 'Stake and access rewards data for ETH and SOL using our API',
    icon: 'developerPlatformNavigation' as PictogramName,
    count: '2',
    unit: 'networks',
  },
  {
    title: 'Community validators',
    description: 'Access to our public validators and onchain addresses',
    icon: 'verifiedPools' as PictogramName,
    count: '18',
    unit: 'networks',
  },
  {
    title: 'Custom validators',
    description: 'Spin up your own custom validators with direct support',
    icon: 'layerNetworks' as PictogramName,
    count: '16',
    unit: 'networks',
  },
];

const networkCountStyle = {
  background: 'var(--secondary)',
  borderRadius: '0 var(--border-radius-rounded) var(--border-radius-rounded) 0',
};

function StakingSolutions() {
  const { isDesktop } = useBreakpoints();
  const columnsTemplate = useMemo(() => {
    return isDesktop ? '1fr 1fr' : '1fr';
  }, [isDesktop]);

  return (
    <Grid templateColumns={columnsTemplate} maxWidth={FULL_PAGE_MAX_WIDTH} gap={8} spacing={7}>
      <VStack justifyContent="center">
        <TextTitle3 as="h2" spacingBottom={2}>
          Complete staking solutions
        </TextTitle3>
        <TextBody as="p" color="foregroundMuted">
          Staking solutions that fit your needs, whether you&apos;re participating in a shared
          environment or managing your own private infrastructure.
        </TextBody>
      </VStack>
      <VStack gap={2}>
        {stakingSolutionsContent.map((item) => (
          <HStack
            key={item.title}
            borderRadius="rounded"
            bordered
            justifyContent="space-between"
            width="100%"
          >
            <HStack alignItems="center" gap={3} spacing={3}>
              <Pictogram scaleMultiplier={0.75} name={item.icon} />
              <VStack>
                <TextHeadline as="p">{item.title}</TextHeadline>
                <TextBody as="p" color="foregroundMuted">
                  {item.description}
                </TextBody>
              </VStack>
            </HStack>
            <VStack
              background="backgroundAlternate"
              justifyContent="center"
              alignItems="center"
              minWidth="100px"
              height="100%"
              style={networkCountStyle}
            >
              <TextHeadline as="p">{item.count}</TextHeadline>
              <TextBody as="p" color="foregroundMuted">
                {item.unit}
              </TextBody>
            </VStack>
          </HStack>
        ))}
      </VStack>
    </Grid>
  );
}

export default StakingSolutions;
